import Home from "./Home";
import NoPage from "./NoPage";
import { BrowserRouter, Routes, Route } from "react-router-dom";

function App() {
    return (
    <>
    <BrowserRouter basename={ process.env.REACT_APP_ROUTER_BASENAME ?? "/" }>
      <Routes>
        <Route path="/:project" element={ <Home/>} />
        <Route path="/:project/:entity_type/:entity_value" element={ <Home/>} />
        <Route path="/:project/filter/:patient" element={ <Home/>} />
        <Route path="/:project/section/:section" element={ <Home/>} />
        <Route path="/:project/:mv" element={ <Home/>} />
        <Route path="/:project/:mv/filter/:patient" element={ <Home/>} />
        <Route path="/:project/:entity_type/:entity_value/:mv" element={ <Home/>} />
        <Route path="/:project/filter/:patient/:mv" element={ <Home/>} />
        <Route path="/:project/section/:section/:mv" element={ <Home/>} />
        <Route path="*" element={<NoPage />} />
      </Routes>
    </BrowserRouter>
    </>
  )
}

export default App;
